import { jsx as t, jsxs as u, Fragment as A } from "react/jsx-runtime";
import { useState as M, useContext as V, createElement as _ } from "react";
import v from "clsx";
import { C as h, s as I, v as L, w as R, u as f, o as y, L as j, t as q, $ as O, a0 as D, Q, S as W, G as b } from "./helpers-458d7e27.js";
import { a as F, u as J, g as K, t as U, b as X } from "./JumpLinkNavGradient-43d260a5.js";
import { N as Y, g as Z, c as H } from "./NavButton-bf29eafc.js";
import { ChevronDownSmIcon as ee } from "@paypalcorp/pp-react-icons";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "react-dom";
const k = "FeatureNavigationColumnItem", te = new h(k), E = ({
  text: e,
  href: a,
  target: i = "_self",
  className: n,
  serverFptiData: o
}) => {
  const { environment: { pageSegment: l = "" } = {} } = I(), s = v(te.getComponentClassName(), n), m = L(
    {
      componentName: k,
      linkText: e,
      serverFptiData: o
    },
    l,
    R.Link
  );
  return /* @__PURE__ */ t("li", { className: s, children: /* @__PURE__ */ t(
    Y,
    {
      linkType: "menu-link",
      buttonType: "link",
      buttonText: e,
      target: i,
      href: a,
      "data-pa-click": m,
      buttonTextSize: "Caption"
    }
  ) });
};
E.displayName = k;
const S = "FeatureNavigationColumnTitle", d = new h(S), $ = ({
  listTitle: e,
  titleHref: a,
  expanded: i,
  onClick: n,
  showTitleArrows: o = !1
}) => {
  const { viewportType: l } = f(), s = ["xs", "sm", "md"].includes(l), { listTitleButtonProps: m } = F({
    isMobile: s,
    expanded: i,
    listTitle: e
  }), r = v(
    d.getComponentClassName(),
    d.getPropsValueClassName("arrow", !!o),
    Z("link", { linkType: "title-link" }),
    H.getComponentClassName()
  );
  return /* @__PURE__ */ u(A, { children: [
    s ? /* @__PURE__ */ u(
      "button",
      {
        ...m,
        type: "button",
        className: d.getComponentClassName(),
        onClick: () => n(),
        children: [
          /* @__PURE__ */ t(y, { as: "span", size: "Caption Bold", children: e }),
          /* @__PURE__ */ t(
            ee,
            {
              className: d.getElementClassName("arrow"),
              size: "sm"
            }
          )
        ]
      }
    ) : /* @__PURE__ */ u("a", { href: a, target: "_self", className: r, children: [
      /* @__PURE__ */ t(
        y,
        {
          as: "span",
          size: "Caption Bold",
          className: d.getElementClassName("text"),
          children: e
        }
      ),
      o && a && /* @__PURE__ */ t(j, { size: "Small" })
    ] }),
    /* @__PURE__ */ t("hr", {})
  ] });
};
$.displayName = S;
const B = "FeatureNavigationColumn", g = new h(B), G = ({
  listTitle: e,
  titleHref: a,
  collection: i,
  showTitleArrows: n = !1,
  openAtStart: o
}) => {
  const { viewportType: l } = f(), [s, m] = M(o), r = ["xs", "sm", "md"].includes(l), p = s || !r || !e, x = q(), { isAboveTheFold: N } = V(O), C = !x && !N, { listProps: z } = F({
    isMobile: r,
    expanded: p,
    listTitle: e
  }), P = v(g.getComponentClassName(), {
    [g.getElementClassName("expanded")]: p
  });
  return J(g.getElementClassName("title")), /* @__PURE__ */ u("div", { className: P, children: [
    e && /* @__PURE__ */ t(
      $,
      {
        listTitle: e,
        titleHref: a,
        showTitleArrows: n,
        expanded: p,
        onClick: () => m(!s)
      }
    ),
    /* @__PURE__ */ t(
      D.div,
      {
        ...z,
        variants: K(C),
        transition: C ? U : { duration: 0 },
        initial: "initial",
        animate: p ? "animate" : "initial",
        children: /* @__PURE__ */ u("ul", { className: g.getElementClassName("list"), children: [
          e && /* @__PURE__ */ t(
            E,
            {
              href: a,
              text: e,
              className: g.getElementClassName("title-cell")
            }
          ),
          i.map((w) => /* @__PURE__ */ t(
            E,
            {
              ...w
            },
            `${e}-${w.text}`
          ))
        ] })
      }
    )
  ] });
};
G.displayName = B;
const T = "FeatureNavigation", c = new h(T), ae = ({
  columns: e,
  showTitleArrows: a,
  ariaLabel: i,
  title: n,
  topSpacer: o = "2vw",
  bottomSpacer: l = "4vw",
  bottomBorder: s = !1
}) => {
  const [m] = Q(["Below LG"]), r = e.some(({ listTitle: N }) => !!N), p = v(
    c.getComponentClassName(),
    c.getPropsValueClassName("titles", r),
    {
      [c.getElementClassName("bottom-bordered")]: s
    }
  ), x = v(
    c.getElementClassName("column"),
    c.getElementClassName("column-expanded"),
    c.getElementClassName("section-title-row")
  );
  return /* @__PURE__ */ u(
    W,
    {
      className: p,
      role: "navigation",
      "aria-label": i,
      options: {
        topSpacing: o,
        bottomSpacing: l
      },
      children: [
        n && m && /* @__PURE__ */ t(b, { children: /* @__PURE__ */ t("div", { className: x, children: /* @__PURE__ */ t(
          y,
          {
            as: "h3",
            size: "Body Bold",
            className: c.getElementClassName("section-title"),
            children: n
          }
        ) }) }),
        e.map((N, C) => /* @__PURE__ */ _(
          b,
          {
            ...X(e.length, C + 1),
            key: `${N.collection[0].text}-column`
          },
          /* @__PURE__ */ t(
            G,
            {
              ...N,
              openAtStart: C === 0,
              showTitleArrows: a
            }
          )
        ))
      ]
    }
  );
};
ae.displayName = T;
export {
  ae as default
};
//# sourceMappingURL=FeatureNavigationSection.js.map
